import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=3a139dd0&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
import style0 from "./Orders.vue?vue&type=style&index=0&id=3a139dd0&prod&scoped=true&lang=css"
import style1 from "./Orders.vue?vue&type=style&index=1&id=3a139dd0&prod&scoped=true&lang=scss"
import style2 from "./Orders.vue?vue&type=style&index=2&id=3a139dd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a139dd0",
  null
  
)

export default component.exports